import { Callout, NonIdealState } from '@blueprintjs/core';
import { Component } from 'react';

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ error: error, errorInfo: errorInfo });
    console.error(error, errorInfo);
    if (error.name === 'ChunkLoadError') {
      alert(
        'There has been an update to the site since you last loaded this module. Reloading to fetch most recent version.',
      );
      window.location.reload(false);
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ background: 'white', padding: 5, borderRadius: 5 }}>
          <Callout>
            <NonIdealState
              icon={'error'}
              title={'Component Error'}
              description={
                <div>
                  The following error occurred in this component or its children
                  ({window.location.toString()}):
                  <Callout
                    style={{ marginTop: 10, marginBottom: 10 }}
                    intent='danger'>
                    {this.state.error?.message || 'Unknown'}
                  </Callout>
                  {this.props.module !== undefined ? (
                    <Callout
                      style={{ marginTop: 10, marginBottom: 10 }}
                      intent='info'>
                      {this.props?.module || 'Unknown Module'}
                    </Callout>
                  ) : (
                    ''
                  )}
                  Please screenshot this error and email it to the development
                  team for debugging.
                </div>
              }
            />
          </Callout>
        </div>
      );
    }
    return this.props.children;
  }
}
